export const formatDocumentDate = (dateString) => {
  if (!dateString) {
    return "Last opened";
  }

  try {
    const date = new Date(dateString);
    
    if (isNaN(date.getTime())) {
      return "Last opened";
    }

    const options = {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    };
    
    const formattedDate = date.toLocaleDateString('en-US', options);
    return `Last update · ${formattedDate}`;
  } catch (error) {
    console.error('Error formatting document date:', error);
    return "Last opened";
  }
};
